<div class="download-dialog-content flex flex-column gap-lg">
  <!-- Format Selection -->
  <div class="section">
    <h4 class="section-title">{{ 'submission.download.format.label' | translate }}</h4>
    <div class="flex flex-wrap gap-md">
      <app-radio name="format" value="xlsx" [(ngModel)]="selectedFormat" [label]="'submission.download.format.xlsx' | translate" data-testid="format-xlsx" />
      <app-radio name="format" value="csv" [(ngModel)]="selectedFormat" [label]="'submission.download.format.csv' | translate" data-testid="format-csv" />
    </div>
  </div>

  <!-- Scope Selection -->
  @if (filteredCount() !== totalCount()) {
  <div class="section">
    <h4 class="section-title">{{ 'submission.download.scope.label' | translate }}</h4>
    <div class="flex flex-wrap gap-md">
      <app-radio name="scope" value="all" [(ngModel)]="selectedScope" [label]="'submission.download.scope.all' | translate:{ count: totalCount().toString() }" data-testid="scope-all" />
      <app-radio name="scope" value="filtered" [(ngModel)]="selectedScope" [label]="'submission.download.scope.filtered' | translate:{ count: filteredCount().toString() }" data-testid="scope-filtered" />
    </div>
  </div>
  }
</div>